import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { useController } from 'react-hook-form'

import Field from './Field'

const Radios = ({ options, control, name }) => {
  const {
    field,
    fieldState: {
      invalid,
      error,
    }
  } = useController({ name, control })

  /*
     In case there is only one option available, just show it
   */
  if (options.length === 1) {
    return (
      <React.Fragment>
        <Form.Control type='hidden' {...field} value={options[0].id} />
        <div className='form-control-plaintext'>{options[0].name}</div>
      </React.Fragment>
    )
  } else {
    return (
      <>
      <Form.Group>
        {options.map((option, index) => (
          <Form.Check
            key={`${name}-${index}`}
            {...field}
            inline
            type='radio'
            id={`${name}-${index}`}
            label={option.name}
            value={option.id}
            checked={field.value === option.id} 
            isInvalid={invalid}
          />
        ))}
      </Form.Group>
      {error && (<span className='text-danger small'>{error.message}</span>)}
      </>
    )
  }
  
}

Radios.propTypes = {
  options: PropTypes.array.isRequired,
  control: PropTypes.any,
  name: PropTypes.string.isRequired,
}

export default Radios
